import React from "react";
import { useState } from "react";
import "./InputText.scss";
import classNames from "classnames";

const InputText = ({
  label,
  value,
  name,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  errorMessage,
  buttonText,
  onButtonClick,
  disableButton,
  disabled,
  maxLength,
  endChild,
  inputType = "text",
  inputMode,
  autoComplete = "on",
  selectTextOnFocus = false,
  isRequired = false
}) => {
  const [focused, setFocused] = useState(false);

  const active = focused || !!value;
  const hasError = !!errorMessage;

  const handleFocus = event => {
    setFocused(true);
    onFocus?.(event);

    if (selectTextOnFocus) {
      event.target.select();
    }
  };

  return (
    <div className="lp_input-text-wrapper">
      <label
        htmlFor={name}
        className={classNames(
          "lp_input-text relative rounded p-1 m-0 border-solid border-1 block flex justify-between overflow-hidden",
          {
            "bg-white": !disabled,
            "border-red-2": hasError,
            "border-gray": !hasError,
            "lp_input-text_disabled": disabled
          }
        )}
      >
        <div className="w-full min-w-0 flex-1">
          <span
            className={classNames(
              "absolute w-full block lp_input-text_label px-2",
              {
                "text-black-9 text-xs.1 lp_input-text_label_active": active,
                "text-black text-sm": !active
              }
            )}
          >
            {isRequired ? `${label}*` : label}
          </span>
          <input
            type={inputType}
            inputMode={inputMode}
            autoComplete={autoComplete === false ? "off" : autoComplete || "on"}
            disabled={disabled}
            maxLength={maxLength}
            id={name}
            name={name}
            className={classNames(
              "outline-none border-none w-full lp_input-text_input text-sm font-medium px-2 py-0",
              {
                "mt-4 lp_input-text_input_active": active
              }
            )}
            value={value ?? ""}
            onChange={e => {
              onChange(e.target.value);
            }}
            onFocus={handleFocus}
            onKeyDown={onKeyDown}
            onBlur={() => {
              setFocused(false);
              onBlur?.();
            }}
          />
        </div>
        {endChild}
        {buttonText ? (
          <button
            disabled={disableButton}
            type={"button"}
            onClick={onButtonClick}
            className={
              "hover.button focus.button bg-yellow text-black px-4 text-xs rounded border-none font-semibold whitespace-nowrap"
            }
          >
            {buttonText}
          </button>
        ) : null}
      </label>
      {hasError && (
        <span className="text-red text-xs mt-1 ml-1 block">{errorMessage}</span>
      )}
    </div>
  );
};

export default InputText;
